import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { useState } from 'react'
import styled from 'styled-components'
const MainComponent = (props: MicroFrontendProps) => {
  const [count, setCount] = useState(0)
  function handleClick() {
    setCount(count + 1)
  }
  const parentURL =
    window?.location != window.parent?.location
      ? document?.referrer
      : document?.location?.href
  const parentOrigin = parentURL ? new URL(parentURL).origin : ''
  console.log(
    'window.location',
    window?.location,
    'window.parent.location',
    window?.parent?.location,
    'document.referrer',
    document?.referrer,
    'document.location.href',
    document?.location?.href
  )
  // @ts-ignore
  const bug = a + b
  return (
    <AppContainer>
      <button onClick={handleClick}>You pressed me {count} times</button>
      <br />
      <p> found parent origin: {parentOrigin}</p>
      <p> found parent URL: {parentURL}</p>
      <br />
      <br />
      <a href={parentOrigin + '/397107702374'} target='_top'>
        Wahldashboard 🔗
      </a>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-size: 1.8rem;
  color: currentColor;
  font-family: var(--font-serif);
  text-align: center;
`
export default MainComponent
